import { CountryCode } from './countries';

const AUSTRALIA_DETAULT_TAX_RATE = 10;
const NEW_ZEALAND_DETAULT_TAX_RATE = 15;

export const DEFAULT_TAX_RATE = {
    [CountryCode.australia]: AUSTRALIA_DETAULT_TAX_RATE,
    [CountryCode.newZealand]: NEW_ZEALAND_DETAULT_TAX_RATE,
};

export const GST_TAX_COUNTRY_CODES = [
    CountryCode.australia,
    CountryCode.newZealand,
];
